module.exports = __webpack_public_path__ + "static/media/logox.2797f739.png";